import React, { Component } from "react";
import {
  View,
  StyleSheet,
  ScrollView,
  TouchableHighlight,
  KeyboardAvoidingView,
} from "react-native";
import Text from "../components_v2/TextFont";
import { connect } from "react-redux";
import Countdown from "../components/CountDown";
import { translate } from "../locales/translate";
import ArButton from "../argon-ui/Button";
import ArTheme from "../argon-ui/Theme";
import * as Actions from "../actions/DeviceActions";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";

import {
  faWifi,
  faAngleLeft,
  faSort,
  faEllipsisHAlt,
  faCctv,
  faPlusCircle,
  faSpeaker,
  faTabletAndroidAlt,
  faFingerprint,
} from "../../assets/consts/faCharCodes";
import * as DeviceTypes from "../components/devices/_deviceTypes";

class DeviceAddScreen extends Component {
  constructor(props) {
    super(props);
    var areaId = undefined;
    var areaUId = undefined;
    if (
      this.props.navigation &&
      this.props.navigation.state.params &&
      (this.props.navigation.state.params.areaId ||
        this.props.navigation.state.params.areaUId)
    ) {
      areaId = this.props.navigation.state.params.areaId;
      areaUId = this.props.navigation.state.params.areaUId;
    }
    this.state = {
      areaId,
      areaUId,
      showTempAreaList: false,
      tempAreaCaller: "",
      tempAreaId: undefined,
      tempAreaUId: undefined,
    };
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.DeviceAdd"),
  });
  componentDidMount() {
    this.setState({
      accessToken: this.props.appReducer.currentServer?.accessToken,
      isLoading: false,
    });
  }

  onIncludeButtonPress = () => {
    // if (Number(this.state.areaId)) {
    //   this.setState({
    //     showTempAreaList: true,
    //     isLoading: false,
    //     tempAreaCaller: "zWave",
    //   });
    // } else
    var _areaId = Number(this.state.tempAreaId);
    var _areaUId = this.state.tempAreaUId;
    if (_areaId) {
      this.props.tryInclude(_areaId, _areaUId, this.state.accessToken);
      this.setState({
        tempAreaId: 0,
        tempAreaUId: undefined,
        isLoading: false,
        tempAreaCaller: "zWave",
      });
    } else {
      this.setState({
        showTempAreaList: true,
        isLoading: false,
        tempAreaCaller: "zWave",
      });
    }
  };

  onAddCameraPress = () => {
    var _areaId = Number(this.state.areaId) || Number(this.state.tempAreaId);
    var _areaUId = this.state.areaUId || this.state.tempAreaUId;
    if (_areaId || _areaUId) {
      this.props.navigation.navigate("CameraForm", {
        areaId: _areaId,
        areaUId: _areaUId,
        onGoBack: (newDeviceType) => {
          typeof this.props.navigation.state.params.onGoBack == "function" &&
            this.props.navigation.state.params.onGoBack(newDeviceType);
          this.props.navigation.goBack();
        },
      });
      this.setState({
        tempAreaCaller: "",
        tempAreaId: undefined,
        tempAreaUId: undefined,
        isLoading: false,
      });
    } else {
      this.setState({
        showTempAreaList: true,
        tempAreaCaller: "camera",
        isLoading: false,
      });
    }
  };

  onAddElevatorPress = () => {
    this.props.navigation.navigate("ElevatorForm", {
      onGoBack: (newDeviceType) => {
        typeof this.props.navigation.state.params.onGoBack == "function" &&
          this.props.navigation.state.params.onGoBack(newDeviceType);
        this.props.navigation.goBack();
      },
    });
    this.setState({
      isLoading: false,
    });
  };

  onAddGPIOPress = (taplifeControllerDeviceUId, taplifeControllerDeviceId) => {
    var _areaId =
      Number(this.state.areaId) || Number(this.state.tempAreaId) || null;
    var _areaUId = this.state.areaUId || this.state.tempAreaUId || null;

    this.props.navigation.navigate("GPIOForm", {
      areaId: _areaId,
      areaUId: _areaUId,
      taplifeControllerDeviceId: taplifeControllerDeviceId,
      taplifeControllerDeviceUId: taplifeControllerDeviceUId,
      onGoBack: (newDeviceType) => {
        typeof this.props.navigation.state.params.onGoBack == "function" &&
          this.props.navigation.state.params.onGoBack(newDeviceType);
        this.props.navigation.goBack();
      },
    });

    this.setState({
      showTempAreaList: false,
      tempAreaCaller: "",
      isLoading: false,
    });
  };

  onAddSmartSpeakerPress = () => {
    var _areaId =
      Number(this.state.areaId) || Number(this.state.tempAreaId) || null;
    var _areaUId = this.state.areaUId || this.state.tempAreaUId || null;

    this.props.navigation.navigate("SmartSpeakerForm", {
      areaId: _areaId,
      areaUId: _areaUId,
      onGoBack: (newDeviceType) => {
        typeof this.props.navigation.state.params.onGoBack == "function" &&
          this.props.navigation.state.params.onGoBack(newDeviceType);
        this.props.navigation.goBack();
      },
    });
    this.setState({
      tempAreaCaller: "",
      tempAreaId: undefined,
      isLoading: false,
    });
  };

  handleOnTempAreaPress = (tempAreaUId, tempAreaId) => {
    this.setState(
      { tempAreaId, tempAreaUId, showTempAreaList: false /*isLoading: true*/ },
      () => {
        if (this.state.tempAreaCaller == "camera") {
          this.onAddCameraPress();
        } else if (this.state.tempAreaCaller == "gpio") {
          this.onAddGPIOPress();
        } else {
          this.onIncludeButtonPress();
        }
      }
    );
  };

  renderPickTempAreaDongle = () => {
    // list of taplifeControllers with dongles attached
    var tlcList = this.props.deviceReducer.list
      .filter(
        (d) =>
          d.deviceType == DeviceTypes.TAPLIFE_CONTROLLER &&
          d.dongles &&
          d.dongles.length > 0
      )
      .map((d) => {
        return {
          deviceId: d.deviceId,
          deviceUId: d.deviceUId,
          deviceName: d.deviceName,
          dongles: d.dongles,
        };
      });

    // list of main areas contains controller
    var mainAreas = this.props.areaReducer.areas
      .filter(
        (ar) =>
          //  ar.isMainArea &&
          // ar.devices.some((ad) => tlcList.map((t) => t.deviceId).indexOf(ad) >= 0)
          ar.accessLevelValue >= 1000
      )
      .map((a) => {
        return {
          areaId: a.areaId,
          areaUId: a.areaUId,
          areaName: a.areaName,
          controllers: tlcList.filter(
            (tlc) =>
              a.devices.indexOf(tlc.deviceId) >= 0 ||
              (Array.isArray(a.uDevices) &&
                a.uDevices.indexOf(tlc.deviceUId) > 0)
          ),
        };
      });

    return (
      <View style={{ flex: 1 }}>
        <Text
          style={{
            paddingHorizontal: 10,
            paddingVertical: 10,
            marginTop: 10,
            fontSize: 18,
          }}
        >
          {translate("area.selectADongle")}
        </Text>
        <ScrollView style={{ marginBottom: 15, flex: 1 }}>
          {mainAreas.map((ar) => {
            return (
              <View
                key={ar.areaUId || ar.areaId}
                style={style.areaIncludeSection}
              >
                <Text>
                  {translate("area.areaName")}: {ar.areaName}
                </Text>
                <View>
                  {tlcList.map((tlc) => {
                    return (
                      <View
                        key={tlc.deviceUId || tlc.deviceId}
                        style={style.areaIncludeSection}
                      >
                        {tlc.dongles.map((zw) => {
                          return (
                            <ArButton
                              key={zw}
                              color="primary"
                              style={style.areaIncludeDongle}
                              onPress={() => {
                                this.setState({ showTempAreaList: false });
                                var homeId = zw.match(/\d+/g)[0]; // extract number part and ignore friendlyName
                                this.props.tryIncludeToHomeId(
                                  ar.areaId,
                                  ar.areaUId,
                                  homeId,
                                  this.state.accessToken
                                );
                              }}
                            >
                              <Text
                                style={{ fontWeight: "bold", color: "#FFF" }}
                              >
                                {translate("deviceGroup.ZWaveDongle")}: {zw}
                              </Text>
                            </ArButton>
                          );
                        })}
                      </View>
                    );
                  })}
                </View>
              </View>
            );
          })}
        </ScrollView>
      </View>
    );
  };

  renderPickTempController = () => {
    // list of taplifeControllers with dongles attached
    var tlcList = this.props.deviceReducer.list
      .filter((d) => d.deviceType == DeviceTypes.TAPLIFE_CONTROLLER)
      .map((d) => {
        return {
          deviceId: d.deviceId,
          deviceUId: d.deviceUId,
          deviceName: d.deviceName,
        };
      });

    return (
      <View>
        <Text
          style={{
            paddingHorizontal: 10,
            paddingVertical: 5,
            marginTop: 10,
            fontSize: 18,
          }}
        >
          {translate("area.selectAController")}
        </Text>
        <ScrollView style={{ marginBottom: 15 }}>
          {tlcList.map((tlc) => {
            return (
              <ArButton
                key={tlc.deviceUId || tlc.deviceId}
                color="primary"
                style={{ width: "100%", marginVertical: 10 }}
                onPress={() => this.onAddGPIOPress(tlc.deviceUId, tlc.deviceId)}
              >
                <Text style={{ fontWeight: "bold", color: "#FFF" }}>
                  {tlc.deviceName}
                </Text>
              </ArButton>
            );
          })}
        </ScrollView>
      </View>
    );
  };

  renderPickTempArea = () => {
    var mainAreas = this.props.areaReducer.areas.filter((ar) => ar.isMainArea);

    return (
      <View>
        <Text style={{ paddingHorizontal: 10, paddingVertical: 5 }}>
          {translate("area.selectAnArea")}
        </Text>
        <ScrollView>
          {mainAreas.map((ar) => {
            return (
              <TouchableHighlight
                style={{
                  paddingHorizontal: 10,
                  paddingVertical: 10,
                  height: 46,
                  justifyContent: "center",
                  backgroundColor: "#eee",
                  margin: 10,
                  marginVertical: 20,
                  borderRadius: 5,
                }}
                underlayColor="#f2f2f2"
                onPress={() =>
                  this.handleOnTempAreaPress(ar.areaUId, ar.areaId)
                }
                key={ar.areaUId || ar.areaId}
              >
                <View style={{ flexDirection: "row" }}>
                  <FontAwesomeIcon
                    icon={faAngleLeft}
                    size={18}
                    style={{ paddingHorizontal: 5 }}
                  />
                  <Text style={{ paddingHorizontal: 10 }}>{ar.areaName}</Text>
                </View>
              </TouchableHighlight>
            );
          })}
        </ScrollView>
      </View>
    );
  };
  // === Touch Panel ===
  onAddTouchPanelPress = () => {
    this.props.navigation.navigate("TouchPanelForm", {
      onGoBack: (newDeviceType) => {
        typeof this.props.navigation.state.params.onGoBack == "function" &&
          this.props.navigation.state.params.onGoBack(newDeviceType);
        this.props.navigation.goBack();
      },
    });
    this.setState({
      tempAreaCaller: "",
      tempAreaId: undefined,
      isLoading: false,
    });
  };
  onAddAccessControlPress = () => {
    var _areaId =
      Number(this.state.areaId) || Number(this.state.tempAreaId) || null;
    var _areaUId = this.state.areaUId || this.state.tempAreaUId || null;

    this.props.navigation.navigate("AccessControlForm", {
      areaId: _areaId,
      areaUId: _areaUId,
      onGoBack: (newDeviceType) => {
        typeof this.props.navigation.state.params.onGoBack == "function" &&
          this.props.navigation.state.params.onGoBack(newDeviceType);
        this.props.navigation.goBack();
      },
    });
    this.setState({
      tempAreaCaller: "",
      tempAreaId: undefined,
      isLoading: false,
    });
  };
  renderButton = (text = "", icon = faWifi, onPress = () => {}) => {
    return (
      <TouchableHighlight
        underlayColor={ArTheme.COLORS.WHITE}
        style={{
          height: 100,
          backgroundColor: ArTheme.COLORS.WHITE,
          borderColor: ArTheme.COLORS.BORDER_COLOR,
          borderWidth: 1,
          width: "40%",
          padding: 10,
          margin: 15,
          borderRadius: 5,
        }}
        onPress={onPress}
      >
        <View>
          <FontAwesomeIcon
            icon={faPlusCircle}
            color={ArTheme.COLORS.PRIMARY}
            size={30}
            style={{
              position: "relative",
              top: -15,
              end: -15,
              marginBottom: -30,
            }}
          />
          <View
            //style={{ flexDirection: "column", justifyContent: "space-between" }}
            style={{ alignItems: "center" }}
          >
            <FontAwesomeIcon
              icon={icon}
              color={ArTheme.COLORS.MUTED}
              size={32}
            />
            <Text style={{ color: ArTheme.COLORS.BLACK, marginTop: 10 }}>
              {text}
            </Text>
          </View>
        </View>
      </TouchableHighlight>
    );
  };

  render() {
    if (this.state.showTempAreaList) {
      if (this.state.tempAreaCaller == "camera") {
        return this.renderPickTempArea();
      } else if (this.state.tempAreaCaller == "gpio") {
        return this.renderPickTempController();
      } else {
        return this.renderPickTempAreaDongle();
      }
    } else if (Number(this.props.deviceReducer.includeTimeout)) {
      var initUntil = Number(this.props.deviceReducer.includeTimeout);

      return (
        <View
          style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
        >
          <Countdown
            until={initUntil}
            digitStyle={{
              backgroundColor: this.state.timerColor,
              borderRadius: 70,
              width: 140,
              height: 140,
              marginBottom: 10,
            }}
            digitTxtStyle={{
              color: "#FFF",
            }}
            size={70}
            timeToShow={["S"]}
            timeLabels={{ s: "" }}
            onChange={(t) => {
              if (t > 7) {
                if (this.state.timerColor != ArTheme.COLORS.PRIMARY) {
                  this.setState({ timerColor: ArTheme.COLORS.PRIMARY });
                }
              } else if (t > 4) {
                if (this.state.timerColor != ArTheme.COLORS.BUTTON_COLOR) {
                  this.setState({ timerColor: ArTheme.COLORS.BUTTON_COLOR });
                }
              } else if (t > 0) {
                if (this.state.timerColor != ArTheme.COLORS.ERROR) {
                  this.setState({ timerColor: ArTheme.COLORS.ERROR });
                }
              } else {
                this.setState({ timerColor: ArTheme.COLORS.PRIMARY });
              }
            }}
            onFinish={() => {
              // set timeout to prevent warning for unmounted component
              setTimeout(() => {
                this.setState({ timerColor: ArTheme.COLORS.PRIMARY }, () =>
                  this.props.resetIncludeTimeout()
                );
              }, 100);
            }}
          />
          <Text style={{ color: ArTheme.COLORS.MUTED }}>
            {translate("device.pressIncludeButton")}
          </Text>
        </View>
      );
    }

    return (
      <KeyboardAvoidingView behavior="padding" style={{ flex: 1 }}>
        <View style={{ flex: 1 }}>
          <Text style={{ margin: 15, fontSize: 16, fontWeight: "bold" }}>
            {translate("device.selectDeviceCategoryFirst")}
          </Text>
          <View
            style={{
              flexDirection: "row",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            {/* add z-wave */}
            {this.renderButton(
              translate("device.ZWaveDevice"),
              faWifi,
              this.onIncludeButtonPress
            )}
            {/* add camera */}
            {this.renderButton(
              translate("device.camera"),
              faCctv,
              this.onAddCameraPress
            )}
            {/* add elevator */}
            {this.renderButton(
              translate("device.elevator"),
              faSort,
              this.onAddElevatorPress
            )}
            {/* add gpio */}
            {this.renderButton(
              translate("device.GPIODevice"),
              faEllipsisHAlt,
              () => {
                this.setState({
                  showTempAreaList: true,
                  tempAreaCaller: "gpio",
                });
              }
            )}
            {/* add smart speaker */}
            {this.renderButton(
              translate("device.SmartSpeaker"),
              faSpeaker,
              this.onAddSmartSpeakerPress
            )}
            {/* === Add Touch Panel === */}
            {this.renderButton(
              translate("touchPanel.touchPanel"),
              faTabletAndroidAlt,
              this.onAddTouchPanelPress
            )}
            {/* === Add AccessControl === */}
            {this.renderButton(
              translate("device.accessControl"),
              faFingerprint,
              this.onAddAccessControlPress
            )}
          </View>
        </View>
      </KeyboardAvoidingView>
    );
  }
}

const style = StyleSheet.create({
  areaIncludeSection: {
    backgroundColor: "#dddddd50",
    paddingVertical: 15,
    paddingHorizontal: 10,
    marginTop: 15,
    alignItems: "center",
  },
  areaIncludeDongle: {
    //  backgroundColor: "#FFF",
    //padding: 15,
    marginHorizontal: 15,
    marginVertical: 10,
    // width : '90%'
    // borderRadius: 10,
  },
});

const mapStateToProps = (state) => {
  return {
    areaReducer: state.AreaReducer,
    deviceReducer: state.DeviceReducer,
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    tryInclude: (areaId, areaUId, accessToken) =>
      dispatch(Actions.TryInclude(areaId, areaUId, accessToken)),
    tryIncludeToHomeId: (areaId, areaUId, homeId, accessToken) =>
      dispatch(
        Actions.tryIncludeToHomeId(areaId, areaUId, homeId, accessToken)
      ),
    resetIncludeTimeout: () => dispatch(Actions.ResetIncludeTimeout()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DeviceAddScreen);
